// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2025-07-16T10:45:51+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  188861
//    Project:        608
//    Environment:    7352 - master
//    MD5:            d1d525c37468ff0509d5e1455354abc2
//    Signature:      eyJpdiI6IkNqQWNwYks0cGdGSGpqZ0xUc2NaUUE9PSIsInZhbHVlIjoiRnJlMlFkWEZvcUV5UFJqSllFcHVqXC9jSlB5dlpmYTZLNTRiRGJlaUs5OHpySWRkTktVcmR6a3hWN25yTGFXNW1KMUpBdkpZZnVkSVVKcHdhZEJwZDJUdm0yQlVKbWEwRFwvTjR5dE53eVlOeUs4UTN2NGs3Wjk2OXhZOEZ6MEhUeHRpQXNhblwvY09Xb1lFaFVKUUNrdVBXalZtejQ4Yk9Pb25xMXBhQW9jcUlEYWdjQVJ6QU5hdW9SNWtYM3FiVURqc2NiWEZzUXAySmQ5dldyK3hReG95WjlwbVFQbERlUGVsSXptSWxURnRncDNpc3BUVFltbWVLWDRRMXJWZkNXaThzTDluRktoSVFmSm5VZDhRamhlQ003U1FwU25zVXkzdzN4YXRxVThzU0VIMFBaV2NcL2FxSm5aUUhWcFFzbkRPNlYydXlPdEdNdGhTZkE3S2g1bXlmSkNlZkNTYTRUd25NM3BOVUJJWkJLNXdyWmVpZWdhU1BBdmlCQytpZ2w0d3hJSzBWWWlFY0lydFBRb2lCSmtCeEE9PSIsIm1hYyI6IjQ0NWFiNzU2MzU2MWQ0MTRiODA0YTcwMjJhYmUwYWNkMDkxMGQxODA5Nzk3MDFkMmM5ZTM4Njg5NjVlN2QxM2QifQ==
class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', onKeyUpEscape);
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open')
  }
}

customElements.define('details-disclosure', DetailsDisclosure);
